import React from "react";
import { Grid } from "@material-ui/core";
import Product from "./Product/Product";
import styles from "./styles";

const Products = ({ products, onAddToCart }) => {
  const classes = styles();
  return (
    //using material-ui grid
    <main className={classes.content}>
      <div className={classes.toolbar} />
      <Grid container justifyContent="center" spacing={4}>
        {products.map((product) => {
          return (
            <Grid item key={product.id} xs={12} sm={6} md={4} ig={3}>
              <Product product={product} onAddToCart={onAddToCart} />
            </Grid>
          );
        })}
      </Grid>
    </main>
  );
};
export default Products;
